module.exports = __webpack_public_path__ + "static/img/achivements.1d1478c.png";


//////////////////
// WEBPACK FOOTER
// ./static/achivements.png
// module id = D04b
// module chunks = 0